const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const {
  leafPedigreesString
} = require('../lib/common');

/**
  * @function evalute - evaluate toStringBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined || value === null) {
    return value;
  }
  if (isPlainObject(value)) {
    const {
      title
    } = value;
    if (title !== undefined) {
      return title;
    }
    return leafPedigreesString(value);
  }
  return value.toString();
};
module.exports = {
  evaluate
};